'use client'
import {Button, Select, SelectItem} from "@nextui-org/react";
import {SQLLanguages, SQLOptions, statementCaseOptions} from "@/formatters/sql";
import Editor from "@monaco-editor/react";
import {
    formatText,
    updateDataTypeCase,
    updateKeywordCase,
    updateSQLLanguage,
    updateText
} from "@/state/features/sqlFormatter";
import {copyToClipboard, saveText} from "@/lib/utils";
import {trackToolAction} from "@/lib/analytics";
import React, {useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from "@/state/hooks";
import {RootState} from "@/state/store";
import {editor} from "monaco-editor";
import EditorWrapper from "@/components/Editor";


const SQLFormatter = () => {
    const dispatch = useAppDispatch();
    const code = useAppSelector((state: RootState) => state.sqlFormatter.text);
    const sqlLanguage = useAppSelector((state: RootState) => state.sqlFormatter.sqlLanguage);
    const keywordCase = useAppSelector((state: RootState) => state.sqlFormatter.keywordCase);
    const dataTypeCase = useAppSelector((state: RootState) => state.sqlFormatter.dataTypeCase);

    const [codeProxy, setCodeProxy] = useState<string>(code);

    function handleEditorChange(value: string | undefined) {
        trackToolAction("sql", "edit");
        if(!!value){
            setCodeProxy(value);
            dispatch(updateText(value))
        }
    }

    const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if(!!e.target.value){
            updateSQLLanguage(e.target.value as SQLLanguages);
        }
    }

    const handleKeywordCaseChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if(!!e.target.value){
            updateKeywordCase(e.target.value);
        }
    }

    const handleDataTypeCaseChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if(!!e.target.value){
            updateDataTypeCase(e.target.value);
        }
    }

    return (
        <div className="w-full flex flex-col items-center">
            <div className="flex my-5 w-full">
                <Select
                    label="Select a Database"
                    labelPlacement="outside"
                    onChange={handleLanguageChange}
                    defaultSelectedKeys={[sqlLanguage]}
                    className="w-1/6"
                >
                    {SQLOptions.map((option) => (
                        <SelectItem key={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </Select>

                <Select
                    label="Keyword Case"
                    labelPlacement="outside"
                    onChange={handleKeywordCaseChange}
                    defaultSelectedKeys={[keywordCase]}
                    className="w-1/6 mx-5"
                >
                    {statementCaseOptions.map((option) => (
                        <SelectItem key={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </Select>

                <Select
                    label="DataType Case"
                    labelPlacement="outside"
                    onChange={handleDataTypeCaseChange}
                    defaultSelectedKeys={[dataTypeCase]}
                    className="w-1/6"
                >
                    {statementCaseOptions.map((option) => (
                        <SelectItem key={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </Select>

            </div>

            <EditorWrapper value={code}  language="sql" changeHandler={handleEditorChange}
            />
            <div className="flex my-5 w-full">
                <Button color="primary" variant="bordered" radius="sm" onClick={() => {
                    trackToolAction("sql", "format");
                    dispatch(formatText(codeProxy))
                }}>Format
                </Button>

                <Button className="mx-5" color="primary" variant="bordered" radius="sm" onClick={async () => {
                    if (code) {
                        trackToolAction("sql", "copy");
                        await copyToClipboard(code)
                    }
                }}>Copy
                </Button>

                <Button color="primary" variant="bordered" radius="sm" onClick={() => {
                    if (code) {
                        trackToolAction("sql", "download");
                        saveText(code, "sql");
                    }
                }}>Download
                </Button>
            </div>
        </div>
    )
}


export default SQLFormatter;
